<template>
  <v-card>
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Estado Partidas</div>
    </v-card>
    <v-card-text>
      <paginated-search-table
        endpoint="/data/lot_inspections"
        ordering="-germination_date"
        searchLabel="Partida"
        :headers="tableHeaders"
        :canEdit="false"
        :canAdd="false"
        :canDelete="false"
        :noIntellySearch="true"
      ></paginated-search-table>
    </v-card-text>
  </v-card>
</template>

<script>
import PaginatedSearchTable from "@/components/PaginatedSearchTable.vue";

export default {
  name: "LotInspectionReport",

  components: {
    PaginatedSearchTable
  },

  data: () => ({
    tableHeaders: [
      { text: "Producto", value: "product_display", sortable: false },
      { text: "Partida", value: "serial_number", sortable: false },
      { text: "Calibre", value: "gauge_description", sortable: false },
      { text: "PG", value: "germination", sortable: false },
      {
        text: "Fecha PG",
        value: "germination_date_formatted",
        sortable: false
      },
      { text: "Placa", value: "seed_plate", sortable: false }
    ]
  }),

  mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.$bRoot.errors = null;
  }
};
</script>
